<template>
  <div>
    <!-- basic information -->
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          :error-messages="errors.birthday"
          v-model="account.birthday"
          :label="$t('SIGNUP.BIRTHDAY')"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          :error-messages="errors.phone"
          v-model="account.phone"
          :label="$t('SIGNUP.PHONE')"
          type="tel"
        />
      </v-flex>

      <template v-if="isArtist">
        <v-flex xs6>
          <v-text-field
            :error-messages="errors.bank_iban"
            v-model="account.bank_iban"
            :label="$t('ACCOUNT.IBAN')"
          />
        </v-flex>
        <v-flex xs6>
          <v-text-field
            :error-messages="errors.bank_swift"
            v-model="account.bank_swift"
            :label="$t('ACCOUNT.SWIFT')"
          />
        </v-flex>
      </template>

      <v-flex xs6>
        <v-text-field
          :error-messages="errors.addressline_1"
          v-model="account.addressline_1"
          :label="$t('SIGNUP.ADDRESS')"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field :error-messages="errors.zip" v-model="account.zip" :label="$t('SIGNUP.ZIP')" />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          :error-messages="errors.city"
          v-model="account.city"
          :label="$t('SIGNUP.CITY')"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          :error-messages="errors.country"
          v-model="account.country"
          :label="$t('SIGNUP.COUNTRY')"
          disabled
          value="Finland"
        />
      </v-flex>
    </v-layout>

    <div v-if="!loading && isArtist">
      <!-- titles -->
      <div class="my-3 pb-3">
        <h3>{{ $t('SIGNUP.PROFESSION') }}</h3>
        <v-layout wrap>
          <v-flex ml-1 pa-0 xs6 sm4 v-for="profession in professions" :key="profession.id">
            <v-checkbox
              class="mt-2 ml-2"
              v-model="account.professions"
              color="primary"
              :label="profession.name"
              :value="profession.id"
              hide-details
            />
          </v-flex>
        </v-layout>
        <div class="mt-2" v-if="errors.professions">
          <p v-for="e in errors.professions" :key="e" class="ma-0 pa-0 red--text">{{ e }}</p>
        </div>
      </div>

      <!-- associations -->
      <div class="my-4">
        <h3>{{ $t('SIGNUP.MEMBER_ASSOC') }}</h3>
        <v-checkbox
          class="mt-2"
          v-for="assoc in associations"
          v-model="account.associations"
          color="primary"
          :key="assoc.id"
          :label="assoc.name"
          :value="assoc.id"
          hide-details
        />
        <div class="mt-2" v-if="errors.associations">
          <p v-for="e in errors.associations" :key="e" class="ma-0 pa-0 red--text">{{ e }}</p>
        </div>
      </div>

      <!-- Finnish assoc -->
      <div class="mb-3">
        <h3>{{ $t('SIGNUP.MEMBER_FINNISH_ARTISTS_ASSOC') }}</h3>
        <v-radio-group v-model="account.finnish_artists_assoc" row class="mt-2">
          <v-radio :label="$tc('COMMON.YES')" :value="true" color="primary" />
          <v-radio :label="$tc('COMMON.NO')" :value="false" color="primary" />
        </v-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";
const translationsRepo = RepositoryFactory.translations();
const handler = new ErrorHandler();

export default {
  props: ["account", "errors", "isArtist"],

  data() {
    return {
      loading: false,
      associations: [],
      professions: []
    };
  },

  created() {
    this.getTranslations();
  },

  methods: {
    async getTranslations() {
      this.loading = true;
      await handler.handle(async () => {
        const res = await translationsRepo.getTranslations(
          "associations,professions"
        );
        this.professions = res.professions;
        this.associations = res.associations;
      });
      this.loading = false;
    }
  }
};
</script>